import { PricelistProductImportPage } from "@/features/pricelist-product/pages/PricelistProductImportPage";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/admin/pricelist/$id/import")({
	validateSearch: z.object({
		periodID: z.string().uuid(),
	}),
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["pricelist.edit"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	const { periodID } = Route.useSearch();
	return (
		<PricelistProductImportPage
			pricelistID={id}
			pricelistPeriodID={periodID}
		/>
	);
}
